export enum MENU_PAGES {
  ADD = 'projects/add',
  PROJECTS = 'projects',
  DOCUMENTS = 'documents',
  CONTACTS = 'contacts',
  PRINT = 'reporting',
  CASHFLOW = 'cashflow',
  SETTINGS = 'settings',
  ACTIVITIES = 'activities',
}

export enum CONTRACTOR_SELECTOR {
  ALL = 'all',
  PREFERRED = 'preferred',
  INVITED = 'invited',
  SCHEDULED = 'scheduled',
}

export const MONTHS_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const MONTHS_LOWERCASE = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];
